export default __webpack_public_path__ + "61042ec09202724cce67c91ce279cc59.svg";